import {makeAutoObservable} from "mobx";
import {api, catchApi} from "../../api";
import {VehicleItemDto} from "../../api/vhs";

class VhsListStore {
    get q(): string | undefined {
        return this._q;
    }

    set q(value: string | undefined) {
        this._q = value;
    }
    get customerId(): string | undefined {
        return this._customerId;
    }

    set customerId(value: string | undefined) {
        this._customerId = value;
    }
    get items(): VehicleItemDto[] {
        return this._items;
    }

    set items(value: VehicleItemDto[]) {
        this._items = value;
    }
    get size(): number {
        return this._size;
    }

    set size(value: number) {
        this._size = value;
    }
    get page(): number {
        return this._page;
    }

    set page(value: number) {
        this._page = value;
    }
    get pages(): number {
        return this._pages;
    }

    set pages(value: number) {
        this._pages = value;
    }

    private _pages: number = 0
    private _page: number = 0
    private _size: number = 25
    private _customerId: string | undefined
    private _q: string | undefined

    private _items: VehicleItemDto[] = []

    constructor() {
        makeAutoObservable(this)
    }

    async load() {
        const {
            page,
            size,
            q,
            customerId
        } = this
        const response = await catchApi(async () => api.vhs.api.listVehicles({
            page: page - 1,
            size,
            q,
            customerIds: customerId ? [customerId] : undefined
        }))

        const responseData = response?.data
        this.pages = responseData?.totalPages || 0

        this.items = responseData?.items || []
    }
}

const vhsListStore = new VhsListStore()

export {
    vhsListStore
}
